import { Fragment, FC } from 'react';
import { fullSize } from 'utils/mixins';
import { SxStyleProp } from 'theme-ui';
import { SceneType } from 'types/Scene';

const DOWNLOAD_PREVIEW_HEIGHT = 80;
const DOWNLOAD_PREVIEW_WIDTH = 142;

const previewStyles: SxStyleProp = {
  ...fullSize,
  bg: 'text',
  pointerEvents: 'none',
  margin: 'auto',
  width: DOWNLOAD_PREVIEW_WIDTH,
  height: DOWNLOAD_PREVIEW_HEIGHT,
  borderRadius: '8px'
};

type PreviewProps = {
  src: string;
  type: SceneType;
};

export const DownloadPreview: FC<PreviewProps> = ({ src, type }) => {
  return src ? (
    <Fragment>
      {type === SceneType.VIDEO && <video sx={previewStyles} src={`${src}`} />}
      {type === SceneType.IMAGE && <img sx={previewStyles} src={`${src}`} alt="" />}
    </Fragment>
  ) : (
    <div sx={previewStyles} />
  );
};
